(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["na-cart"] && !Shopify.designMode) return;
  try {
    
(function(){
'use strict';

/* ── Quantity +/- via AJAX ── */
document.querySelectorAll('.cart-qty-minus,.cart-qty-plus').forEach(function(btn){
  btn.addEventListener('click',function(){
    var key=btn.dataset.key;
    var numEl=btn.closest('.cart-item-qty').querySelector('.cart-qty-num');
    var current=parseInt(numEl.textContent,10);
    var newQty=btn.classList.contains('cart-qty-minus')?Math.max(0,current-1):current+1;
    fetch('/cart/change.js',{
      method:'POST',
      headers:{'Content-Type':'application/json'},
      body:JSON.stringify({id:key,quantity:newQty})
    }).then(function(){window.location.reload();});
  });
});

/* ── Remove item ── */
document.querySelectorAll('.cart-item-remove').forEach(function(btn){
  btn.addEventListener('click',function(){
    fetch('/cart/change.js',{
      method:'POST',
      headers:{'Content-Type':'application/json'},
      body:JSON.stringify({id:btn.dataset.key,quantity:0})
    }).then(function(){window.location.reload();});
  });
});

/* ── Upsell add buttons ── */
document.querySelectorAll('.cart-up-btn').forEach(function(btn){
  btn.addEventListener('click',function(){
    var id=btn.dataset.id;
    btn.disabled=true;btn.textContent='Adding\u2026';
    fetch('/cart/add.js',{
      method:'POST',
      headers:{'Content-Type':'application/json'},
      body:JSON.stringify({items:[{id:parseInt(id,10),quantity:1}]})
    }).then(function(r){return r.json();}).then(function(){
      btn.textContent='Added \u2713';btn.classList.add('added');
      setTimeout(function(){window.location.reload();},800);
    }).catch(function(){btn.disabled=false;btn.textContent='Add';});
  });
});

/* ── Hide upsells already in cart ── */
(function(){
  fetch('/cart.js').then(function(r){return r.json();}).then(function(c){
    var ids=c.items.map(function(i){return String(i.variant_id);});
    document.querySelectorAll('.cart-up').forEach(function(card){
      if(ids.indexOf(card.dataset.id)>-1){card.style.display='none';}
    });
  }).catch(function(){});
})();

/* ── Subscribe toggle (visual — Appstle handles actual subscription on checkout) ── */
var subToggle=document.getElementById('cart-sub-toggle');
if(subToggle){
  subToggle.addEventListener('click',function(){
    subToggle.classList.toggle('active');
    var isActive=subToggle.classList.contains('active');
    subToggle.setAttribute('aria-checked',String(isActive));
    /* 
      NOTE: Appstle subscription integration.
      When the Appstle app is installed and selling plans are configured,
      this toggle should update the cart items to include the selling_plan ID.
      For now this is a visual toggle. The actual subscription enrollment happens
      via Appstle's native widget or by adding ?selling_plan=<plan_id> to the
      cart add request. Configure the plan ID in Appstle admin after setup.
    */
  });
  subToggle.addEventListener('keydown',function(e){
    if(e.key===' '||e.key==='Enter'){e.preventDefault();subToggle.click();}
  });
}

/* ── Sticky mobile bar ── */
var sticky=document.getElementById('cart-sticky');
if(sticky){var t=false;window.addEventListener('scroll',function(){
  if(!t){requestAnimationFrame(function(){sticky.classList.toggle('show',window.scrollY>200);t=false;});t=true;}
},{passive:true});}

})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["na-landing"] && !Shopify.designMode) return;
  try {
    
(function(){
'use strict';

/* ── Meta Pixel ViewContent ── */
(function(){
  if(typeof fbq!=='function') return;
  try{fbq('track','ViewContent',{content_name:'Night Agent Protocol',content_type:'product',value:85.00,currency:'USD'});}catch(e){}
})();

/* ── Reveal on scroll ── */
var obs=new IntersectionObserver(function(e){
  e.forEach(function(e){if(e.isIntersecting){e.target.classList.add('on');obs.unobserve(e.target);}});
},{threshold:0.08,rootMargin:'0px 0px -28px 0px'});
document.querySelectorAll('.revel').forEach(function(el){obs.observe(el);});

/* ── Sticky mobile bar ── */
var sticky=document.getElementById('lp-sticky');
if(sticky){
  var t=false;
  window.addEventListener('scroll',function(){
    if(!t){requestAnimationFrame(function(){sticky.classList.toggle('show',window.scrollY>500);t=false;});t=true;}
  },{passive:true});
}

/* ── FAQ accordion ── */
document.querySelectorAll('.lp-faq-q').forEach(function(btn){
  btn.addEventListener('click',function(){
    var item=btn.closest('.lp-faq-item');
    var isOpen=item.classList.contains('open');
    document.querySelectorAll('.lp-faq-item').forEach(function(i){
      i.classList.remove('open');
      i.querySelector('.lp-faq-q').setAttribute('aria-expanded','false');
    });
    if(!isOpen){item.classList.add('open');btn.setAttribute('aria-expanded','true');}
  });
});

/* ── Pixel on add to cart ── */
['lp-form-hero','lp-form-kit','lp-form-final'].forEach(function(id){
  var f=document.getElementById(id);
  if(f){f.addEventListener('submit',function(){
    if(typeof fbq==='function'){try{fbq('track','AddToCart',{value:85.00,currency:'USD'});}catch(e){}}
  });}
});

/* ── Smooth scroll to proof ── */
document.querySelectorAll('a[href="#proof"]').forEach(function(a){
  a.addEventListener('click',function(e){
    e.preventDefault();
    var t=document.getElementById('proof');
    if(t) window.scrollTo({top:t.getBoundingClientRect().top+window.scrollY-60,behavior:'smooth'});
  });
});

})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["na-science"] && !Shopify.designMode) return;
  try {
    
(function(){
'use strict';

/* ── Reveal on scroll ── */
var obs = new IntersectionObserver(function(entries){
  entries.forEach(function(e){
    if(e.isIntersecting){e.target.classList.add('on');obs.unobserve(e.target);}
  });
},{threshold:0.08,rootMargin:'0px 0px -32px 0px'});
document.querySelectorAll('.revel').forEach(function(el){obs.observe(el);});

/* ── Mechanism accordion ── */
document.querySelectorAll('.sci-mech-btn').forEach(function(btn){
  btn.addEventListener('click',function(){
    var mech = btn.closest('.sci-mech');
    var isOpen = mech.classList.contains('open');
    document.querySelectorAll('.sci-mech').forEach(function(m){
      m.classList.remove('open');
      m.querySelector('.sci-mech-btn').setAttribute('aria-expanded','false');
    });
    if(!isOpen){
      mech.classList.add('open');
      btn.setAttribute('aria-expanded','true');
    }
  });
});

/* ── TOC active state on scroll ── */
var sections = ['sleep-os','mechanisms','inputs','performance','safety','sources'];
var tocLinks = {};
sections.forEach(function(id){
  var el = document.querySelector('.sci-toc-link[data-section="'+id+'"]');
  if(el) tocLinks[id] = el;
});

var secObs = new IntersectionObserver(function(entries){
  entries.forEach(function(e){
    if(e.isIntersecting){
      Object.values(tocLinks).forEach(function(l){l.classList.remove('active');});
      var link = tocLinks[e.target.id];
      if(link) link.classList.add('active');
    }
  });
},{rootMargin:'-20% 0px -70% 0px'});

sections.forEach(function(id){
  var el = document.getElementById(id);
  if(el) secObs.observe(el);
});

/* ── Smooth scroll for TOC ── */
document.querySelectorAll('.sci-toc-link').forEach(function(a){
  a.addEventListener('click',function(e){
    e.preventDefault();
    var id = a.getAttribute('data-section');
    var target = document.getElementById(id);
    if(target){
      var offset = 108; /* nav + toc height */
      var top = target.getBoundingClientRect().top + window.scrollY - offset;
      window.scrollTo({top:top,behavior:'smooth'});
    }
  });
});

})();

  } catch(e) { console.error(e); }
})();
})();
